export const TIPOS_PEDIDO = [
    { value: 0, label: "Delivery" },
    { value: 1, label: "Retirada" },
    { value: 2, label: "Mesa" },
]

export const SITUACOES = [
    { value: "AGUARDANDO_ACEITACAO", label: "Aguardando Aceitação" },
    { value: "CONFIRMADO", label: "Aceito" },
    { value: "EM_PRODUCAO", label: "Em Produção" },
    { value: "PRONTO", label: "Pronto" },
    { value: "EM_ENTREGA", label: "Em Entrega" },
    { value: "ENTREGUE", label: "Entregue" },
    { value: "CANCELADO", label: "Cancelado" },
]

export const PLATAFORMAS = [
    { value: "CARDAPIO_DIGITAL", label: "Cardápio Digital" },
    { value: "CENTRAL_DE_PEDIDOS", label: "Central de Pedidos" },
    { value: "IFOOD", label: "iFood" },
    { value: "NOVE_FOOD", label: "99 Food" },
]

export const TIPOS_FORMA_PAGAMENTO = [
    { value: "CARTAO", label: "Cartão" },
    { value: "DINHEIRO", label: "Dinheiro" },
    { value: "PIX", label: "Pix" },
    { value: "VOUCHER", label: "Voucher" },
    { value: "REFEICAO", label: "Refeição" },
    { value: "OUTROS", label: "Outros" },
]

export const PAGE_SIZE_OPTIONS = [50, 100, 200, 500]

export const formatarMoeda = valor =>
    Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(valor || 0)

export const corDoStatus = descricao => {
    const d = (descricao || "").toLowerCase()
    if (d.includes("entregue") || d.includes("pago")) return "#28a745"
    if (d.includes("em entrega") || d.includes("aceito") || d.includes("confirmado"))
        return "#0080ff"
    if (d.includes("produção") || d.includes("producao")) return "#c0392b"
    if (d.includes("cancelad") || d.includes("expirad")) return "#6c757d"
    if (d.includes("aguardando") || d.includes("pronto")) return "#f0ad4e"
    return "#6c757d"
}

export const corStatusPill = descricao => {
    const d = (descricao || "").toLowerCase()
    if (d.includes("entregue") || d.includes("finalizad") || d.includes("pago"))
        return { bg: "#d1fae5", color: "#047857" }
    if (d.includes("em entrega") || d.includes("aceito") || d.includes("confirmado"))
        return { bg: "#dbeafe", color: "#2563eb" }
    if (d.includes("produção") || d.includes("producao") || d.includes("em preparo"))
        return { bg: "#dbeafe", color: "#2563eb" }
    if (d.includes("cancelad") || d.includes("expirad"))
        return { bg: "#fee2e2", color: "#b91c1c" }
    if (d.includes("aguardando")) return { bg: "#fef3c7", color: "#92400e" }
    if (d.includes("pronto")) return { bg: "#ede9fe", color: "#6d28d9" }
    return { bg: "#f3f4f6", color: "#374151" }
}

export const rotuloTipo = tipo => {
    if (tipo === 0 || tipo === "0") return "Delivery"
    if (tipo === 1 || tipo === "1") return "Retirada"
    if (tipo === 2 || tipo === "2") return "Mesa"
    if (typeof tipo === "string") return tipo
    return "—"
}

// Mesma regra do sistemaadm (Util.obterPlataformaFormatada + PlataformaDispositivo), usada
// enquanto o backend não envia `plataformaFormatada`. Sem o solicitante (pedido lançado pela
// central), que só o backend conhece.
const plataformaFormatadaLocal = p => {
    const bruta = p.plataforma || ""
    const s = bruta.toLowerCase()
    if (!s) return "Site"
    if (/cfnetwork|alamofire|ios|react_native_ios/.test(s)) return "IOS"
    if (/android|okhttp|dalvik|react_native_android/.test(s)) return "Android"
    if (s.includes("izzabot")) return "Izza"
    if (s === "central de pedidos" || s.includes("react_js_central_de_pedidos"))
        return "Central de Pedidos"
    if (s.includes("ifood")) return "iFood"
    if (s.includes("didi_food")) return "99 Food"
    if (s === "site" || s.includes("react_js_site")) return "Site"
    const tipo = String(p.type)
    if (tipo === "0" && p.deliveryAddress?.id > 0) return "Site"
    if (tipo === "2" && p.mesa != null) return "Site"
    if (tipo === "1" && p.mesa == null) return "Site"
    return bruta
}

// Rótulo da coluna Plataforma, nos mesmos grupos do filtro: site e apps (Android/iOS/Izza)
// = "Cardápio Digital"; Central de Pedidos; iFood; 99 Food.
export const plataformaPedido = p => {
    const formatada = p.plataformaFormatada || plataformaFormatadaLocal(p)
    if (["Site", "Android", "IOS", "Izza"].includes(formatada)) return "Cardápio Digital"
    return formatada
}

export const tipoPill = tipo => {
    const label = rotuloTipo(tipo)
    const t = label.toLowerCase()
    if (t === "delivery") return { label, bg: "#dbeafe", color: "#2563eb" }
    if (t === "retirada") return { label, bg: "#e0f2fe", color: "#0369a1" }
    if (t === "mesa") return { label, bg: "#ede9fe", color: "#6d28d9" }
    return { label, bg: "#f3f4f6", color: "#374151" }
}
